import { inject, Service } from '@angular/core'
import { Router } from '@angular/router'
import { catchError, EMPTY, map, Subscription, switchMap, timer } from 'rxjs'

import { AuthApi } from '../auth-api/auth-api'

/** Consulta si la sesión sigue habilitada y redirige a donde diga el backend. */
@Service()
export class AuthRequirementsPoller {
  #authApi = inject(AuthApi)
  #router = inject(Router)
  #subscription?: Subscription

  readonly #POLL_INTERVAL = 30 * 1000

  /** Consulta de inmediato y luego cada 30 s. Seguro de llamar varias veces. */
  start(): void {
    this.stop()

    this.#subscription = timer(0, this.#POLL_INTERVAL)
      .pipe(
        switchMap(() =>
          this.#authApi.checkRequirements().pipe(
            catchError(error => {
              console.error('Falló la verificación de requisitos de sesión:', error)
              return EMPTY
            })
          )
        ),
        map(result => {
          if (!result.allowed) this.#router.navigate([result.redirect_page])
        })
      )
      .subscribe()
  }

  stop(): void {
    this.#subscription?.unsubscribe()
    this.#subscription = undefined
  }

  isActive(): boolean {
    return this.#subscription !== undefined && !this.#subscription.closed
  }
}
